import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsLayersHalf, BsWechat } from "react-icons/bs";
import { FaBars, FaTimes } from "react-icons/fa";
import DataContext from "../ContextServer/DataContext";
import logo from "../images/naju_logo.png";

const Header = () => {
  const { adminChange, setAdminChange, adminLogin, setAdminLogin } =
    useContext(DataContext);

  const [isToggled, setIsToggled] = useState(false); // 모바일 화면에서 햄버거 버튼 Toggle
  const toggleSide = () => {
    setIsToggled(!isToggled);
  };

  useEffect(() => {
    var windowMatchMedia = window.matchMedia("screen and (max-width : 799px)");
    setIsToggled(!windowMatchMedia.matches);
  }, []);

  window
    .matchMedia("screen and (max-width : 799px)")
    .addEventListener("change", (a) => {
      // 모바일 -> PC
      if (a.matches === false) {
        setIsToggled(true);
      }
      // PC -> 모바일
      else {
        setIsToggled(false);
      }
    });

  const navigate = useNavigate();
  const handleLogo = () => {
    navigate("/odor");
  };

  return (
    <>
      <div className={`header-container ${isToggled ? "mobile" : ""}`}>
        <div className={`header-title ${isToggled ? "mobile" : ""}`}>
          {/* 로고 */}
          <div className="logo-container">
            <img
              src={logo}
              alt="naju-logo"
              className="logo"
              onClick={handleLogo}
            />
          </div>

          <div className="toggle" onClick={toggleSide}>
            {isToggled ? <FaTimes /> : <FaBars />}
          </div>

          {/* 메뉴 리스트 */}
          <ul className="header__menulist">
            <li className="h_monitering">
              <Link to="/odor" onClick={toggleSide}>
                <BsLayersHalf style={{ marginRight: 8 }} />
                모니터링
              </Link>
            </li>
            <li className="h_declare">
              <Link to="/odor/declare" onClick={toggleSide}>
                <BsWechat style={{ marginRight: 8 }} />
                악취신고
              </Link>
            </li>
            {/* <li className="h_info">
              <Link to="/information" >
                <BsFillPinAngleFill
                  style={{ marginRight: 8 }} />
                정보마당
              </Link>
            </li>
            <li className="h_notice">
              <Link to="/notice" >
                <BsMegaphoneFill style={{ marginRight: 8 }}
                  className="toggle-mobile"
                />
                공지사항
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
      <div className="content">{/* 페이지 콘텐츠 */}</div>
    </>
  );
};

export default Header;
